export type VehicleCatalogueColorProperties = {
  name: 'color_code';
  value: string;
};
